/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;
export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/c/bio/:author/:articleGUID',
    channel: null,
    varnish: true
  },
});
